import { logoBoxSx } from 'components/styles/box';
import { Box } from 'components/ui';
import logo from 'assets/images/logo.png';

const Logo = ({ width = 200, className = '', children }) => {
  return (
    <Box sx={logoBoxSx} className={className}>
      <img src={logo} alt="Logo" width={width} />
      {children}
    </Box>
  );
};

export default Logo;
